import { DateObject } from '@capsicum/common';
import { Text } from '@capsicum/common-web';

export const TimeField = ({ value }: { value: string }) => {
	const date = new DateObject(value);

	// Manually format the date string
	const formattedDate = `${date.hour().toString().padStart(2, '0')}:${date.minute().toString().padStart(2, '0')}`;

	// The formatted date will be in the format: 06:23
	return <Text variant="text1">{formattedDate}</Text>;
};
